import React from 'react';
import CallChatbotManager from './shared/CallChatbotManager';

// Standalone call chatbot page for the logged-in client managing their own
// chatbots. No client id is sent — the backend resolves the client from the
// auth token.
function CallChatbot() {
	return (
		<div className="p-16">
			<CallChatbotManager />
		</div>
	);
}

export default CallChatbot;
